import { NOW } from 'context/DateProvider/DateProvider';
import { convertNowToISO } from 'context/DateProvider/utils/convertNowToISO';

export const parseDateQueryParam = (dateString: string) => {
  const regex = /now(?<sign>[+-])(?<number>[0-9]{1,2})(?<granularity>[mhd])/;
  const match = dateString.match(regex);

  if (match || dateString === NOW) {
    return new Date(convertNowToISO(dateString));
  }
  return new Date(dateString);
};
